import { Button, Empty } from "antd";
import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { openPopup2 } from "../../../../contexts/PopupContext";
import { OpService } from "../../../../util/services/operation";
import { showErrorResponse } from "../../../../util/varibles/global";
import { IOperation, IOperations } from "../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../util/varibles/message";
import { planOpActions } from "../../reducer";
import InvoiceRelatedSelector from "./InvoiceRelatedSelector";
import styles from "./style.module.scss";

interface IProps {
    data: IOperation
    operations: IOperations
    onClose?(): void
}

const PopupInvoiceRelated: React.FC<IProps> = ({ data, operations, onClose }) => {
    const dispatch = useDispatch();
    const selectedIds = useMemo(
        () => (data.operation.invoices || []).map(item => item.operation_id),
        [data.operation.invoices]
    );
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState<string[]>(selectedIds);
    const [invoices, setInvoices] = useState(data.operation.invoices || []);

    const handleSubmit = () => {
        const selectedEventIds = new Set(
            invoices
                .filter(item => item.operation_id !== data.operation.id)
                .map(item => item.operation_id)
        );
        const previousEventIds = (data.operation.invoices || [])
            .filter(item => item.operation_id !== data.operation.id)
            .map(item => item.operation_id);
        const eventIds = new Set([...previousEventIds, ...Array.from(selectedEventIds)]);
        const update = Array.from(eventIds).reduce<IOperations>((result, id) => {
            const event = operations[id];
            if (!event)
                return result;

            result[id] = {
                ...event,
                operation: {
                    ...event.operation,
                    invoices: selectedEventIds.has(id) ? invoices : [],
                },
            };
            return result;
        }, {
            [data.operation.id]: {
                ...data,
                operation: { ...data.operation, invoices },
            },
        });

        setLoading(true);
        OpService.updateInvoiceRelated({ invoices })
            .then(() => {
                dispatch(planOpActions.updateOpsByWs({ data: Object.values(update), mode: 'update-without-level' }));
                notify.success(NotifyCode.S2)([`Operation #${data.operation.operation_code}`]);
                onClose?.();
            })
            .catch(error => {
                showErrorResponse('Update failed', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return <>
        <InvoiceRelatedSelector
            operation={data.operation}
            activityLog={data.activity_log}
            operations={operations}
            vesselId={data.vessel.id}
            value={value}
            className={styles.events}
            empty={<Empty className={styles.empty} image={Empty.PRESENTED_IMAGE_SIMPLE} description="No related events available" />}
            showLinks
            isEdit={!loading}
            onChange={(value, invoices) => {
                setValue(value);
                setInvoices(invoices);
            }}
        />
        <Button
            className={`bt-primary mt-2 ${styles.submit}`}
            data-full='true'
            loading={loading}
            onClick={handleSubmit}
        >
            Select
        </Button>
    </>;
};

const openPopupInvoiceRelated = (props: Omit<IProps, 'onClose'>) => openPopup2(
    <PopupInvoiceRelated {...props} />,
    {
        modalProps: {
            width: 460,
            title: "Select related event for invoice",
            className: styles.popup,
        },
    },
);

export default openPopupInvoiceRelated;
